import './viewplans.css';
import React, { useState } from "react";
import Logo from '../../header/images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheck, 
  faGraduationCap, 
  faGamepad, 
  faCertificate, 
  faChartLine, 
  faClock, 
  faHeadset,
  faShieldAlt,
  faLock,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";



const Viewplans = () => {

const [open, setOpen] = useState(null);
const [billingCycle, setBillingCycle] = useState('annual'); // 'monthly' or 'annual'

  const navigate = useNavigate();

const closePage = () => {
  if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate("/userpage");
  }
};


  return (
    <div className="plans-page-professional">
      {/* Header modern */}
      <div className="header-professional">
        <div className="header-content-professional">
          <img src={Logo} alt="ContaLearn" className="logo-professional" onClick={() => navigate('/')} />
          <button className="close-btn-professional" onClick={closePage}>
            <span>×</span>
          </button>
        </div>
      </div>

      {/* Hero Section */}
      <div className="hero-section-professional">
        <div className="hero-badge">🎓 Investește in cariera ta</div>
        <h1 className="hero-title-professional">
          Alege planul perfect pentru tine
        </h1>
        <p className="hero-subtitle-professional">
          Invata contabilitate modern, structurat si eficient. Peste 10,000 de utilizatori au ales deja ContaLearn.
        </p>
      </div>

      {/* Pricing Cards */}
      <div className="pricing-container-professional">
        
        {/* Plan GRATUIT */}
        <div className="pricing-card-professional free-plan">
          <div className="plan-header-professional">
            <h3 className="plan-name-professional">Gratuit</h3>
            <div className="plan-price-professional">
              <span className="price-amount-professional">0</span>
              <span className="price-currency-professional">LEI</span>
            </div>
            <p className="plan-description-professional">Pentru cei care vor sa incerce</p>
          </div>

          <div className="plan-features-professional">
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>5 lectii gratuite pe saptamana</span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Acces la comunitate</span>
            </div>
            <div className="feature-item-professional inactive">
              <span className="x-icon-professional">×</span>
              <span>Exercitii practice</span>
            </div>
            <div className="feature-item-professional inactive">
              <span className="x-icon-professional">×</span>
              <span>Certificare</span>
            </div>
            <div className="feature-item-professional inactive">
              <span className="x-icon-professional">×</span>
              <span>Suport prioritar</span>
            </div>
          </div>

          <button className="plan-button-professional outline" onClick={() => navigate('/plangratuit')}>
            Incepe gratuit
          </button>
        </div>

        {/* Plan LUNAR */}
        <div className="pricing-card-professional">
          <div className="plan-header-professional">
            <h3 className="plan-name-professional">Premium Lunar</h3>
            <div className="plan-price-professional">
              <span className="price-amount-professional">70</span>
              <span className="price-currency-professional">LEI/lună</span>
            </div>
            <p className="plan-description-professional">Perfect pentru flexibilitate</p>
          </div>

          <div className="plan-features-professional">
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Acces nelimitat la toate cursurile</span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>300+ lectii interactive</span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Exercitii si aplicatii practice</span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Jocuri educationale</span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Anulare oricand</span>
            </div>
          </div>

          <button
            className="plan-button-professional"
            onClick={() => navigate('/planlunar')}
          >
            Selectează planul
          </button>
        </div>

        {/* Plan ANUAL - RECOMMENDED */}
        <div className="pricing-card-professional recommended">
          <div className="recommended-badge">CEL MAI POPULAR</div>
          <div className="plan-header-professional">
            <h3 className="plan-name-professional">Premium Anual</h3>
            <div className="plan-price-professional">
              <span className="price-amount-professional">550</span>
              <span className="price-currency-professional">LEI/an</span>
            </div>
            <p className="plan-description-professional">
              Doar <strong>45.83 LEI/lună</strong> • Economisești 290 LEI
            </p>
          </div>

          <div className="plan-features-professional">
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span><strong>Tot ce ofera planul lunar</strong></span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Certificat de finalizare</span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Acces prioritar la continut nou</span>
            </div>
            <div className="feature-item-professional">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span>Suport dedicat</span>
            </div>
            <div className="feature-item-professional highlight">
              <FontAwesomeIcon icon={faCheck} className="feature-icon-professional" />
              <span><strong>Economisesti 290 LEI</strong></span>
            </div>
          </div>

          <button
            className="plan-button-professional primary"
            onClick={() => navigate('/plananual')}
          >
            Începe acum
          </button>
          <p className="money-back-guarantee">💚 Garantie de rambursare 14 zile</p>
        </div>

      </div>

      {/* Social Proof Section */}
      <div className="social-proof-section-professional">
        <div className="stats-grid-professional">
          <div className="stat-item-professional">
            <div className="stat-number-professional">10,000+</div>
            <div className="stat-label-professional">Utilizatori activi</div>
          </div>
          <div className="stat-item-professional">
            <div className="stat-number-professional">4.8/5</div>
            <div className="stat-label-professional">Rating mediu</div>
          </div>
          <div className="stat-item-professional">
            <div className="stat-number-professional">300+</div>
            <div className="stat-label-professional">Lectii disponibile</div>
          </div>
          <div className="stat-item-professional">
            <div className="stat-number-professional">98%</div>
            <div className="stat-label-professional">Rata de satisfactie</div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section-professional">
        <h2 className="section-title-professional">Tot ce ai nevoie pentru a deveni expert in contabilitate</h2>
        
        <div className="features-grid-professional">
          <div className="feature-card-professional">
            <div className="feature-icon-wrapper-professional">
              <FontAwesomeIcon icon={faGraduationCap} />
            </div>
            <h3>Cursuri complete si structurate</h3>
            <p>De la bazele contabilitatii pana la concepte avansate de contabilitate financiara, tot intr-un singur loc.</p>
          </div>

          <div className="feature-card-professional">
            <div className="feature-icon-wrapper-professional">
              <FontAwesomeIcon icon={faGamepad} />
            </div>
            <h3>Jocuri educationale interactive</h3>
            <p>Invata prin practica cu aplicatii si jocuri care transforma teoria in experienta reala.</p>
          </div>

          <div className="feature-card-professional">
            <div className="feature-icon-wrapper-professional">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <h3>Certificare recunoscuta</h3>
            <p>Primesti un certificat oficial de finalizare pe care il poti prezenta la angajatori.</p>
          </div>

          <div className="feature-card-professional">
            <div className="feature-icon-wrapper-professional">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <h3>Urmarire progres personalizata</h3>
            <p>Vezi exact unde te afli in parcursul tau de invatare si ce mai ai de invatat.</p>
          </div>

          <div className="feature-card-professional">
            <div className="feature-icon-wrapper-professional">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <h3>Invata in ritmul tau</h3>
            <p>Acces 24/7 la toate resursele, invata cand si unde vrei tu.</p>
          </div>

          <div className="feature-card-professional">
            <div className="feature-icon-wrapper-professional">
              <FontAwesomeIcon icon={faHeadset} />
            </div>
            <h3>Suport dedicat</h3>
            <p>Echipa noastra este aici sa te ajute oricand ai nevoie de indrumare.</p>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="testimonials-section-professional">
        <h2 className="section-title-professional">Ce spun utilizatorii nostri</h2>
        
        <div className="testimonials-grid-professional">
          <div className="testimonial-card-professional">
            <div className="testimonial-rating-professional">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text-professional">
              "ContaLearn m-a ajutat sa inteleg contabilitatea de la zero. Acum lucrez ca contabil si totul datorita acestei platforme!"
            </p>
            <div className="testimonial-author-professional">
              <strong>Maria Popescu</strong>
              <span>Contabil junior</span>
            </div>
          </div>

          <div className="testimonial-card-professional">
            <div className="testimonial-rating-professional">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text-professional">
              "Lectiile sunt clare, structurate logic si usor de urmat. Jocurile interactive fac invatarea mai interesanta."
            </p>
            <div className="testimonial-author-professional">
              <strong>Ion Ionescu</strong>
              <span>Student</span>
            </div>
          </div>

          <div className="testimonial-card-professional">
            <div className="testimonial-rating-professional">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text-professional">
              "Certificatul primit la final m-a ajutat sa imi gasesc un job mai bun. Investitia perfecta in cariera mea!"
            </p>
            <div className="testimonial-author-professional">
              <strong>Elena Dumitrescu</strong>
              <span>Specialist financiar</span>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Badges Section */}
      <div className="trust-section-professional">
        <div className="trust-badges-professional">
          <div className="trust-badge-professional">
            <FontAwesomeIcon icon={faShieldAlt} />
            <span>Plati securizate SSL</span>
          </div>
          <div className="trust-badge-professional">
            <FontAwesomeIcon icon={faLock} />
            <span>Date protejate GDPR</span>
          </div>
          <div className="trust-badge-professional">
            <FontAwesomeIcon icon={faClock} />
            <span>Anulare oricand</span>
          </div>
          <div className="trust-badge-professional">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span>Garantie 14 zile</span>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faq-section-professional">
        <h2 className="section-title-professional">Intrebari frecvente</h2>
        <div className="faq-container-professional">
          {/* 1 */}
          <div className="faq-item-professional" onClick={() => setOpen(open === 1 ? null : 1)}>
            <div className="faq-question-professional">
              <span>Ce include abonamentul Premium?</span>
              <span className="faq-icon-professional">{open === 1 ? "−" : "+"}</span>
            </div>
            {open === 1 && (
              <div className="faq-answer-professional">
                Acces complet la peste 300 de lectii video, aplicatii interactive, jocuri educationale, teste de final de capitol si certificat de finalizare recunoscut.
              </div>
            )}
          </div>

          {/* 2 */}
          <div className="faq-item-professional" onClick={() => setOpen(open === 2 ? null : 2)}>
            <div className="faq-question-professional">
              <span>Pot anula oricand abonamentul?</span>
              <span className="faq-icon-professional">{open === 2 ? "−" : "+"}</span>
            </div>
            {open === 2 && (
              <div className="faq-answer-professional">
                Da, poti anula oricand direct din contul tau, fara costuri suplimentare. Vei avea acces pana la finalul perioadei platite.
              </div>
            )}
          </div>

          {/* 3 */}
          <div className="faq-item-professional" onClick={() => setOpen(open === 3 ? null : 3)}>
            <div className="faq-question-professional">
              <span>Pot invata de pe telefon si desktop?</span>
              <span className="faq-icon-professional">{open === 3 ? "−" : "+"}</span>
            </div>
            {open === 3 && (
              <div className="faq-answer-professional">
                Da, poti invata de pe orice dispozitiv: telefon, laptop sau tableta. Progresul tau se sincronizeaza automat pe toate dispozitivele.
              </div>
            )}
          </div>

          {/* 4 */}
          <div className="faq-item-professional" onClick={() => setOpen(open === 4 ? null : 4)}>
            <div className="faq-question-professional">
              <span>Este potrivit si pentru avansati?</span>
              <span className="faq-icon-professional">{open === 4 ? "−" : "+"}</span>
            </div>
            {open === 4 && (
              <div className="faq-answer-professional">
                Da! Avem cursuri pentru toate nivelurile, de la incepatori pana la contabilitate financiara avansata si pregatire pentru examenele de certificare.
              </div>
            )}
    </div>

          {/* 5 */}
          <div className="faq-item-professional" onClick={() => setOpen(open === 5 ? null : 5)}>
            <div className="faq-question-professional">
              <span>Primesc certificat la final?</span>
              <span className="faq-icon-professional">{open === 5 ? "−" : "+"}</span>
            </div>
            {open === 5 && (
              <div className="faq-answer-professional">
                Da, la finalul cursului, dupa ce ai completat lectiile si testele, primesti un certificat de finalizare pe care il poti adauga in CV sau LinkedIn.
              </div>
            )}
          </div>

          {/* 6 */}
          <div className="faq-item-professional" onClick={() => setOpen(open === 6 ? null : 6)}>
            <div className="faq-question-professional">
              <span>Este potrivit pentru incepatori?</span>
              <span className="faq-icon-professional">{open === 6 ? "−" : "+"}</span>
            </div>
            {open === 6 && (
              <div className="faq-answer-professional">
                Absolut! Cursurile sunt structurate de la nivel incepator pana la avansat. Vei invata pas cu pas toate conceptele necesare.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div className="final-cta-professional">
        <h2>Incepe sa inveti contabilitate astazi</h2>
        <p>Peste 10,000 de utilizatori au ales deja ContaLearn. Tu ce astepti?</p>
        <button
          className="cta-button-professional"
          onClick={() => navigate('/offerdiscount?plan=annual')}
        >
          Obține acces complet
        </button>
        <p className="cta-disclaimer-professional">Garantie de rambursare 14 zile • Anulare oricand • Suport dedicat</p>
      </div>

    </div>
  );
};

export default Viewplans;
